// extracted by mini-css-extract-plugin
export default {"Footer":"Footer_Footer__gqWc-","Footer__Divider":"Footer_Footer__Divider__GDmRo","Footer__Warning":"Footer_Footer__Warning__RzL2R","Footer__Buttons":"Footer_Footer__Buttons__Et1HL"};